import React, { useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { PaginationProps } from "antd/es/pagination";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, mianCode } from "@/utils/constants";
import { IPgProps, ISearchPage } from "@/types/ScmTypes";
import { IMaterialDetail, IMaterialSearchFields, materialService, IFormGoodsFields, IMaterialBases, IMaterialBasesSearch, IMaterialBasesDetail } from "./materialService";
import { globalPrompt } from "@/components/message";
import { convertRes2Blob } from "@/utils/exportFile";
import { warehouseService, IShelfFileds } from "../warehouse/warehouseService"
import { useGlobalModel, getFindItem } from "@/model/globalModel";
import { useDictModel } from "../dict/dictModel";
import { DictCodeEnmu, sourceAppOrBranch } from "@/types/VrmSaDictEnums"
import { transPgToPagination } from "@/utils/utils";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
type ISCMFormVal = {
    photo?: string[]
    [key: string]: any
}

export const useGoodsModel = createModel(function () {
    const { user, warehouseList,setLocale } = useGlobalModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const Locale = setLocale(LanguageArr)
    const { getTreeNodeName } = useDictModel();

    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    /**
     * 列表
     */

    //列表数据源
    const [dataSource, setDataSource] = useState<IMaterialDetail[]>([]);
    //查询条件
    const [searchParam, setSearchParam] = useState<IMaterialSearchFields>({});
    //分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //实时货位数据
    const [shelfAllList, setShelfAllList] = useState<IShelfFileds[]>([])

    //列表查询
    const loadData = async (page?: ISearchPage, searchValue: IMaterialSearchFields = searchParam) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await materialService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
    }
    //设置搜索value
    const updateSearchParam = (updateParam: IMaterialSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }

    /** 
     * 表单详情
     */

    //编辑表单缓存
    const [editFormVal, setEditFormVal] = useState<ISCMFormVal>({});
    //新增表单缓存
    const [addFormVal, setAddFormVal] = useState<ISCMFormVal>({ limitUpper: 0, limitLower: 0 });
    //表单新增修改
    const updateAddFormVal = (val: object | null) => {
        console.log(val)
        val ? setAddFormVal({ ...addFormVal, ...val }) : setAddFormVal({});
    }
    //表单新增修改
    const updateEditFormVal = (val: object | null) => {
        val ? setEditFormVal({ ...editFormVal, ...val }) : setEditFormVal({});
    }
    //获取一条详情数据 Api
    const getGoodsOne = async (id: string) => {
        let { retData } = await materialService.one(id);
        let newRetData = { ...retData }
        console.log(newRetData)
        retData && setEditFormVal(newRetData);
    }

    //表单新增 Api
    const insertGoods = async (data: IMaterialBases) => {
        let params = {
            ...data,
            // ...sourceAppOrBranch,
            sourceApp: mianCode,
            branch: mianCode,
            enable: data.enable ? 1 : 0,
            createUser: user.username,
            brandName: getTreeNodeName(data.brandCode as string),
            unitName: getTreeNodeName(data.unitCode as string),
            typeName: getTreeNodeName(data.typeCode as string),
            warehouseId: getFindItem(data.warehouseCode as string, warehouseList)?.id,
            warehouseName: getFindItem(data.warehouseCode as string, warehouseList)?.name,
            shelfId: getFindItem(data.shelfCode as string, shelfAllList)?.id,
            limitUpper: Number(data.limitUpper),
            limitLower: Number(data.limitLower),
            purchasePrice: Number(data.purchasePrice),
            retailPrice: Number(data.retailPrice),
        }
        let { retData } = await materialService.insert(params);
        retData ?
            // loadData() && globalPrompt("message", { text: "配件商品新增成功", type: "success" })
            // : globalPrompt("message", { text: "配件商品新增失败", type: "error" });
            loadData() && globalPrompt("message", { text: Locale["Successfully added"], type: "success" })
            : globalPrompt("message", { text: Locale["Unsuccessfully added"], type: "error" });
        return retData;
    }

    //表单编辑 Api
    const editGoods = async (data: IMaterialBases) => {
        let params = {
            ...data,
            // ...sourceAppOrBranch,
            sourceApp: mianCode,
            branch: mianCode,
            enable: data.enable ? 1 : 0,
            updateUser: user.username,
            brandName: getTreeNodeName(data.brandCode as string),
            unitName: getTreeNodeName(data.unitCode as string),
            typeName: getTreeNodeName(data.typeCode as string),
            warehouseId: getFindItem(data.warehouseCode as string, warehouseList)?.id,
            warehouseName: getFindItem(data.warehouseCode as string, warehouseList)?.name,
            shelfId: getFindItem(data.shelfCode as string, shelfAllList)?.id,
            limitUpper: Number(data.limitUpper),
            limitLower: Number(data.limitLower),
            purchasePrice: Number(data.purchasePrice),
            retailPrice: Number(data.retailPrice),
        }
        let { retData } = await materialService.update(params);
        retData ?
            // loadData() && globalPrompt("message", { text: "配件商品编辑成功", type: "success" })
            // : globalPrompt("message", { text: "配件商品编辑失败", type: "error" });
            loadData() && globalPrompt("message", { text: Locale["Successfully edited"], type: "success" })
            : globalPrompt("message", { text: Locale["Unsuccessfully edited"], type: "error" });
        return retData;
    }
    const onDisabled = async (id: string, checked: boolean) => {
        let { retData } = await materialService.disable({ id, enable: checked ? 1 : 0 });
        retData ?
            // loadData() && globalPrompt("message", { text: "配件商品编辑成功", type: "success" })
            // : globalPrompt("message", { text: "配件商品编辑失败", type: "error" });
            loadData() && globalPrompt("message", { text: Locale["Successfully edited"], type: "success" })
            : globalPrompt("message", { text: Locale["Unsuccessfully edited"], type: "error" });
        return retData;
    }
    //导入
    const importGoods = async (file: { file: File }) => {
        let { retData } = await materialService.import(file);
        retData ?
            // loadData() && globalPrompt("message", { text: "导入成功", type: "success" })
            // : globalPrompt("message", { text: "导入失败", type: "error" });
            loadData() && globalPrompt("message", { text: Locale["Successfully imported"], type: "success" })
            : globalPrompt("message", { text: Locale["Unsuccessfully imported"], type: "error" });
        return retData;
    }

    //导入物料图片
    const importImgGoods = async (file: { file: File }) => {
        let { retData } = await materialService.import(file);
        retData ?
            loadData() && globalPrompt("message", { text: "导入图片成功", type: "success" })
            : globalPrompt("message", { text: "导入图片失败", type: "error" });
        return retData;
    }

    //导出
    const exportGoods = async (searchValue: IMaterialSearchFields = searchParam) => {
        const searchParams = {
            ...searchValue,
            pageSize: pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let result = await materialService.export(searchParams);
        // retData ?
        //     globalPrompt("message", { text: "导出成功", type: "success" })
        //     : globalPrompt("message", { text: "导出失败", type: "error" });
        convertRes2Blob(result)
        return result;
    }
    //下载模板
    const downloadTpl = async (id: string) => {
        let result = await materialService.downloadTpl();
        convertRes2Blob(result)
        return result;
    }

    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        editFormVal,
        addFormVal,
        shelfAllList,
        updateAddFormVal,
        updateEditFormVal,
        insertGoods,
        editGoods,
        getGoodsOne,
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        importGoods,
        exportGoods,
        downloadTpl,
        importImgGoods,
        setAddFormVal,
        setEditFormVal,
        onDisabled,
        setShelfAllList
    }
});